import { cva } from 'class-variance-authority';

/**
 * shadcn/ui-style Button variants, themed to the Serene Sanctuary palette.
 * - `primary`   → Deep Emerald CTAs (top nav Donate, hero Register, etc.)
 * - `secondary` → Warm-gold CTAs (Stitch "Join Community", "Register Now")
 * - `outline`   → Bordered ghost buttons used on hero overlays
 * - `ghost`     → Transparent text buttons (nav links, "BOOK NOW" arrows)
 * - `glass`     → Glass-card style for buttons sitting over imagery
 *
 * Extracted into its own module so {@code button.tsx} exports only the
 * `Button` component — keeping React Fast Refresh's component-only-export
 * rule satisfied.
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap font-label-caps text-label-caps transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 focus-visible:ring-offset-surface disabled:pointer-events-none disabled:opacity-50 active:scale-[0.98]',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-on-primary hover:bg-primary-container shadow-sm',
        secondary:
          'bg-secondary-container text-on-secondary-container hover:bg-secondary shadow-sm',
        outline:
          'border border-outline-variant text-on-surface hover:border-primary hover:text-primary',
        ghost: 'text-on-surface-variant hover:text-primary',
        glass:
          'glass-card bg-white/10 text-white border-white/20 hover:bg-white/20 backdrop-blur-md',
        destructive: 'bg-error text-on-error hover:bg-error/90',
      },
      size: {
        sm: 'h-9 px-4 rounded-lg',
        md: 'h-11 px-6 rounded-lg',
        lg: 'h-14 px-8 rounded-lg text-[14px]',
        icon: 'h-10 w-10 rounded-lg',
        pill: 'h-9 px-6 rounded-full',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);
